import React, { useEffect } from 'react'
 import Cookies from 'js-cookie'

function Logout() {

    let stop:any = Date.now();

    const clearCookies=()=>{
        Cookies.remove('thrucd')
         Cookies.remove('thrgpcd')	
      Cookies.remove('thrtk')
      localStorage.setItem('_expt', stop)
      localStorage.setItem('_bexpt', stop)
    }

 useEffect(()=>{  
  clearCookies()
  window.open("/", '_self')
  
},[]); 

  return (
    <div>...please wait</div>
  )
}

export default Logout